export const marketReports = [
  {
    id: "2026-07",
    label: "Juillet 2026",
    shortLabel: "Juil. 2026",
    status: "Édition publiée",
    guideSlug: "avignon-investir-vivre-vendre",
    guideTitle: "Guide Avignon",
    propertyCity: "Avignon",
    propertyLabel: "Biens à Avignon",
    sectors: [
      { city: "Avignon", signal: "Demande soutenue", trend: "Stable", direction: "stable" },
      { city: "L'Isle-sur-la-Sorgue", signal: "Projets réfléchis", trend: "En hausse", direction: "up" },
      { city: "Luberon", signal: "Offre sélective", trend: "À surveiller", direction: "watch" },
    ],
  },
  {
    id: "2026-08",
    label: "Août 2026",
    shortLabel: "Août 2026",
    status: "Édition préparée",
    guideSlug: "isle-sur-la-sorgue-investir-vivre-vendre",
    guideTitle: "Guide L'Isle-sur-la-Sorgue",
    propertyCity: "L'Isle-sur-la-Sorgue",
    propertyLabel: "Biens à L'Isle-sur-la-Sorgue",
    sectors: [
      { city: "Avignon", signal: "Recherche ciblée", trend: "Stable", direction: "stable" },
      { city: "L'Isle-sur-la-Sorgue", signal: "Adresses singulières", trend: "En hausse", direction: "up" },
      { city: "Luberon", signal: "Décisions de projet", trend: "À surveiller", direction: "watch" },
    ],
  },
  {
    id: "2026-09",
    label: "Septembre 2026",
    shortLabel: "Sept. 2026",
    status: "Édition préparée",
    guideSlug: "luberon-investir-vivre-vendre",
    guideTitle: "Guide Luberon",
    propertyCity: "Gordes",
    propertyLabel: "Biens du Luberon",
    sectors: [
      { city: "Avignon", signal: "Rentrée résidentielle", trend: "En hausse", direction: "up" },
      { city: "L'Isle-sur-la-Sorgue", signal: "Valeur du cadre de vie", trend: "Stable", direction: "stable" },
      { city: "Luberon", signal: "Projets long terme", trend: "Stable", direction: "stable" },
    ],
  },
  {
    id: "2026-10",
    label: "Octobre 2026",
    shortLabel: "Oct. 2026",
    status: "Édition préparée",
    guideSlug: "avignon-investir-vivre-vendre",
    guideTitle: "Guide Avignon",
    propertyCity: "Avignon",
    propertyLabel: "Biens à Avignon",
    sectors: [
      { city: "Avignon", signal: "Offre à comparer", trend: "À surveiller", direction: "watch" },
      { city: "L'Isle-sur-la-Sorgue", signal: "Extérieurs recherchés", trend: "Stable", direction: "stable" },
      { city: "Luberon", signal: "Patrimoine sélectif", trend: "En hausse", direction: "up" },
    ],
  },
];

export const upcomingReportMonths = [];